import React from "react";
import clsx from "clsx";

type Props = {
  role: "assistant" | "user";
  children: React.ReactNode;
};

export function ChatBubble({ role, children }: Props) {
  const isAssistant = role === "assistant";
  return (
    <div className={clsx("w-full flex", isAssistant ? "justify-start" : "justify-end")}>
      <div
        className={clsx(
          "max-w-[85%] rounded-2xl px-4 py-2 shadow-sm",
          "text-sm leading-relaxed",
          isAssistant
            ? "bg-[#E8F1FF] text-[#0A1A2B]"     // IA à esquerda
            : "bg-white text-[#111827]"          // Usuário à direita
        )}
        // sem borda; efeito de "parte do ambiente"
      >
        {children}
      </div>
    </div>
  );
}